export const LIST_PRODUCT_REFERENCE_ENTITIES_STATE_KEY =
  'list-product-reference-entities';
